module.exports = __webpack_public_path__ + "img/Wisdomchain.e67bd45a.png";